module.exports = __webpack_public_path__ + "static/media/localhackday1st.8fdcf389.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/localhackday1st.JPG
// module id = 845
// module chunks = 0